import * as React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import * as Site from '../../shared/Site';
import { IProductCompensation, IProductType, IProductProps } from './Entities';

interface ProductGroupListRowProps {
    productCompensation: IProductCompensation;
    productTypes: IProductType[];
    delete: (id: number, product: number) => void;
}

const ProductGroupListRow = (props: ProductGroupListRowProps) => {
    let product = getProduct(props.productTypes, props.productCompensation.productId);

    return (
        <tr className={Site.getOrderCssClass(product.site.id)}>
            <td>{product.name}</td>
            <td className="num">{props.productCompensation.compensation}</td>
            <td>
                <ButtonToolbar className="pull-right">
                    <Button
                        onClick={() => {
                            props.delete(
                                props.productCompensation.id,
                                props.productCompensation.productId
                            );
                        }}
                        bsStyle="danger"
                    >
                        <i className="material-icons">delete </i>
                        {Translate('agreements/modal/list/row/button-label/delete')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

function getProduct(productTypes: IProductType[], productId: number): IProductProps {
    let filteredProduct = productTypes
        .map((pt: IProductType) => {
            let filteredProduct = pt.products.filter((p: IProductProps) => {
                return p.id.toString() === productId.toString();
            })[0];

            if (filteredProduct) {
                return filteredProduct;
            }
        })
        .filter((x: any) => {
            return x !== undefined;
        })[0];

    return filteredProduct;
}

export default ProductGroupListRow;
